const billerCrossReferenceActionTypes = {
    GET_BILLER_CROSS_REFERENCE_SUCCESS: "GET_BILLER_CROSS_REFERENCE_SUCCESS",
    GET_BILLER_CROSS_REFERENCE_ERROR: "GET_BILLER_CROSS_REFERENCE_ERROR",
    AUTHENTICATED_LINKED_BILLER_FLAG_SUCCESS: "AUTHENTICATED_LINKED_BILLER__FLAG_SUCCESS",
    AUTHENTICATED_LINKED_BILLER__FLAG_ERROR: "AUTHENTICATED_LINKED_BILLER__FLAG_ERROR"

};

export default billerCrossReferenceActionTypes;
